import { GRADES } from '../config/constants';
import type { IScoringEvaluation } from '../types';

export const createGrade = ({ score, lowLimit, midLimit }: IScoringEvaluation): string => {
  if (score) {
    if (score > midLimit) {
      return GRADES.HIGH;
    }
    if (score > lowLimit) {
      return GRADES.MID;
    }
  }

  return GRADES.LOW;
};

export const createDescription = ({ score, lowLimit, midLimit }: IScoringEvaluation): string => {
  if (score) {
    return `У вас ${createGrade({ score, lowLimit, midLimit })} кредитный рейтинг`;
  }

  return 'Рейтинг не найден';
};
